import { ActivityIndicator, ScrollView, StyleSheet, View } from "react-native";
import type { BodyFigure, PainMap } from "@heraion/shared";
import { PainMapPicker, resolveTheme, type UiTheme } from "@heraion/ui";

import { useThemePalette } from "./theme";
import { useShellProfile } from "./ThemeProfileBridge";

// Me → Pain map on the web console: the picker alone, full width, with its
// +/- zoom. Mirror of mobile's MePainMap (inbox 63d06cce), in Me since
// #315. Reached from its Me row, the Home card and the logger's veto line.
export function PainMapScreen() {
  const { dark, family } = useThemePalette();
  const theme = resolveTheme(dark, family);
  const { doc, loading, savePatch } = useShellProfile();
  const styles = makeStyles(theme);

  if (loading) {
    return (
      <View style={styles.center}>
        <ActivityIndicator color={theme.palette.ink2} />
      </View>
    );
  }

  return (
    <ScrollView style={styles.flex} contentContainerStyle={styles.body}>
      <PainMapPicker
        theme={theme}
        isDark={dark}
        initialPainMap={(doc?.["painMap"] as PainMap | undefined) ?? {}}
        // As the mobile shim: no default here, BodyMap draws unset as masculine.
        figure={doc?.["preferredFigure"] as BodyFigure | undefined}
        savePainMap={(next) => savePatch({ painMap: next })}
      />
    </ScrollView>
  );
}

function makeStyles(theme: UiTheme) {
  const { palette: p, spacing: s } = theme;
  return StyleSheet.create({
    flex: { flex: 1, backgroundColor: p.bg },
    body: { paddingHorizontal: s.s5, paddingVertical: s.s4 },
    center: { flex: 1, alignItems: "center", justifyContent: "center", backgroundColor: p.bg },
  });
}
